module.exports = __webpack_public_path__ + "static/media/regulatory_med.2438197b.jpg";